import cloudSlice from "../slices/cloudSlice";

export const { cloudCreateUserFailure, cloudCreateUserRequest, cloudCreateUserSuccess } =
  cloudSlice.actions;
